export default () => {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.quantityBtns = this.querySelectorAll('.quantity__button')
      this.removeBtns = this.querySelectorAll('.cart-remove-button')
    }

    connectedCallback() {
      // Event listeners for quantity buttons
      this.quantityBtns.forEach(button => {
        button.addEventListener('click', this.updateQuantity.bind(this));
      });

      // Event listeners for remove buttons
      this.removeBtns.forEach(button => {
        button.addEventListener('click', this.removeItem.bind(this));
      });
    }

    disconnectedCallback() {
      this.quantityBtns.forEach(button => {
        button.removeEventListener('click', this.updateQuantity.bind(this));
      });

      this.removeBtns.forEach(button => {
        button.removeEventListener('click', this.removeItem.bind(this));
      });
    }

    updateQuantity(event) {
      const button = event.currentTarget;
      const action = button.getAttribute('name');
      const quantityElement = button.closest('.cart-quantity').querySelector('.quantity__input');
      const variantId = quantityElement.getAttribute('data-quantity-variant-id');
      let quantity = parseInt(quantityElement.textContent, 10);

      if (action === 'plus') {
        quantity += 1;
      } else if (action === 'minus' && quantity > 1) {
        quantity -= 1;
      }

      this.updateCart(variantId, quantity);
    }

    removeItem(event) {
      const button = event.currentTarget;
      const variantId = button.getAttribute('data-variant-id');
      this.updateCart(variantId, 0);
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
          items: [{
            item_name: `${button.getAttribute('data-title')}`,
            item_id: `${variantId}`,
            price: `${button.getAttribute('data-price')}`,
            item_brand: `${button.getAttribute('data-vendor')}`,
            item_category: ``,
            item_category2: '',
            item_category3: '',
            item_category4: '',
            item_variant: `${button.getAttribute('data-variant-title')}`,
            quantity: 0
          }
          ]
        }
      })
    }

    updateCart(variantId, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity
        })
      })
        .then(response => response.json())
        .then(data => {
          this.updateCartDisplay(data);
          document.querySelectorAll('.cart-products-qty').forEach(qty=>{
            // eslint-disable-next-line
            qty.innerHTML = data.item_count
          })
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('Error updating cart:', error);
        });
    }

    updateCartDisplay(cart) {
      cart.items.forEach(item => {
        const quantityElement = this.querySelector(`.quantity__input[data-quantity-variant-id="${item.variant_id}"]`);
        if (quantityElement) {
          quantityElement.textContent = item.quantity;
        }
      });

      // Remove items with zero quantity
      this.querySelectorAll('.cart-remove-button').forEach(button => {
        const variantId = button.getAttribute('data-variant-id');
        const item = cart.items.find(elem => elem.variant_id === parseInt(variantId, 10));
        if (!item) {
          const cartItem = button.closest('[data-section="cart-item"]');
          if (cartItem) {
            cartItem.remove();
          }
        }
      });

      document.querySelectorAll('.cart-total-price').forEach(item=>{
        // eslint-disable-next-line
        item.textContent = this.formatMoney({
          amount: cart.total_price,
          currencyCode: Shopify.currency.active
        }, true);
      })
    }

    formatMoney({amount, currencyCode = 'USD'}, cents = false) {
      let amt = amount;
      if (Number.isNaN(amt))
        // eslint-disable-next-line no-console
        return console.error('utils/format-money.js: No amount value passed.');

      if (cents) amt /= 100;

      const isWholeNumber = amt % 1 === 0;

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: isWholeNumber ? 0 : 2,
        maximumFractionDigits: 2,
      });

      return formatter.format(amt);
    };


  }

  const init = () => {
    if (!customElements.get('cart-items')) {
      customElements.define('cart-items', CartItems);
    }
  };

  init();
};
